import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'infra-largest_contentful_paint-view';

/**
 * General event for capturing the Largest Contentful Paint (FCP) metric.
 */
export function trackInfraLargestContentfulPaintView(
  name: string,
  loadType2: string,
  lcp3: string,
  attribution4: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { name, loadType2, lcp3, attribution4 },
  });
}
